import { useEffect, useRef, useState } from "react";
import api from "@/lib/api";

// Global-ish live price poller (shared cache to avoid duplicate calls)
let _priceListeners = [];
let _priceData = null;
let _priceTimer = null;

function startPricePolling() {
  if (_priceTimer) return;
  const tick = async () => {
    try {
      const d = await api.price();
      _priceData = d;
      _priceListeners.forEach((fn) => fn(d));
    } catch (_) {}
  };
  tick();
  _priceTimer = setInterval(tick, 15000);
}

export function usePrice() {
  const [price, setPrice] = useState(_priceData);
  useEffect(() => {
    const fn = (d) => setPrice(d);
    _priceListeners.push(fn);
    startPricePolling();
    if (_priceData) setPrice(_priceData);
    return () => {
      _priceListeners = _priceListeners.filter((f) => f !== fn);
    };
  }, []);
  return price;
}

export function useNow(intervalMs = 1000) {
  const [, setTick] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setTick((n) => n + 1), intervalMs);
    return () => clearInterval(t);
  }, [intervalMs]);
  return Date.now();
}

export function usePolling(fn, deps = [], intervalMs = 20000) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const saved = useRef(fn);
  saved.current = fn;
  useEffect(() => {
    let alive = true;
    const run = async () => {
      try {
        const d = await saved.current();
        if (alive) setData(d);
      } catch (_) {
      } finally {
        if (alive) setLoading(false);
      }
    };
    run();
    const t = setInterval(run, intervalMs);
    return () => {
      alive = false;
      clearInterval(t);
    };
    // eslint-disable-next-line
  }, deps);
  return { data, loading, reload: async () => setData(await saved.current()) };
}
